import { render, staticRenderFns } from "./DispensaItensTodos.vue?vue&type=template&id=76e10df8&scoped=true&"
import script from "./DispensaItensTodos.vue?vue&type=script&lang=js&"
export * from "./DispensaItensTodos.vue?vue&type=script&lang=js&"
import style0 from "./DispensaItensTodos.vue?vue&type=style&index=0&id=76e10df8&lang=scss&scoped=true&"
import style1 from "./DispensaItensTodos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e10df8",
  null
  
)

export default component.exports